import { render, staticRenderFns } from "./ResponsiveLayout.vue?vue&type=template&id=68d626b6&"
import script from "./ResponsiveLayout.vue?vue&type=script&lang=ts&"
export * from "./ResponsiveLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports